module.exports = __webpack_public_path__ + "static/media/spouse-ss-vs-fra.0fb792ac.svg";